import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {Interceptor} from '@jobseeker/common-core/components/Inteceptor';
import useValidateAuth from '@jobseeker/common-core/hooks/useValidateAuth';
import {wrapper} from '@jobseeker/common-core/stores';
import {TrackEventUBA} from '@jobseeker/common-core/utils';

import {NavLayout, ResponsiveLayout, SeoLayout} from '@layouts';
import {
  EPOCH_TERMS,
  EPOCH,
  EPOCH_WINNERS,
  ALIAS_TO_COMPETITION_ID,
} from '@constants';

import loadSEO from '@helpers/loadSEO';
import {EpochWinners} from '@components/Competition';

import {metaInfo} from '@configs';
import {getConfigByApp} from '@utils';
import {VersionVariants} from '@jobseeker/lotus/enums';
import type {GetServerSidePropsContext} from 'next/types';
import {competitionService} from '@jobseeker/common-core/services';

type CompetitionTermsProps = {
  seoConfig: object;
};

const CompetitionTerms = ({seoConfig}: CompetitionTermsProps) => {
  const metaData = getConfigByApp(metaInfo, EPOCH, true, EPOCH_TERMS);

  const dispatch =
    /* eslint-disable @typescript-eslint/no-explicit-any */ useDispatch<any>();

  useValidateAuth(dispatch);

  useEffect(() => {
    TrackEventUBA('marketingPageView', 'view', {
      pageName: 'EPOCH Winner',
      initiativeName: `EPOCH${new Date().getFullYear()}`,
    });
  }, []);

  return (
    <>
      <Interceptor metaInfo={metaData}>
        <SeoLayout seoConfig={seoConfig} paginationEnabled={true} />
        <NavLayout page={EPOCH}>
          <ResponsiveLayout
            variant={VersionVariants.VERSION_TWO}
            breadcrumbElements={[]}
          >
            <EpochWinners />
          </ResponsiveLayout>
        </NavLayout>
      </Interceptor>
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async (context: GetServerSidePropsContext) => {
    const seoConfig = await loadSEO(EPOCH_WINNERS);
    store.dispatch({
      type: 'AppContext/set_current_page',
      payload: {page: EPOCH_WINNERS},
    });
    const alias = (context.query.alias as string) || 'epoch';

    const competitionId = ALIAS_TO_COMPETITION_ID[alias];

    const timelineInfo = await competitionService.fetchTimelineData(
      competitionId
    );

    if (
      timelineInfo?.registration &&
      Object.keys(timelineInfo?.registration).length > 0
    ) {
      store.dispatch({
        type: 'Competition/set_timeline_data',
        payload: {competition: timelineInfo},
      });
    }

    return {
      props: {
        seoConfig,
      },
    };
  }
);

export default CompetitionTerms;
